<div class="admin-navbar">
    <div class="logo-admin">
        <img
            src="assets/images/logo-admin.webp"
            appImgFallback="/assets/images/logo-admin.png"
            alt="Admin Logo"
            loading="lazy"
            height="40"
            width="40"
        />
    </div>

    <div class="navbar-container">
        <nav class="navigation-nav">
            <a
                routerLink="/admin/requests"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="navigation-item__container--selected"
                class="navigation-item__container"
            >
                <div class="item-icon-container">
                    <mat-icon class="icon-m item-icon">inbox</mat-icon>
                </div>
                <span class="body-m item-description">Requests</span>
            </a>
            <a
                routerLink="/admin/catalogue"
                [routerLinkActiveOptions]="{ exact: true }"
                *appFeatureToggling="'catalogue'"
                routerLinkActive="navigation-item__container--selected"
                class="navigation-item__container"
            >
                <div class="item-icon-container">
                <mat-icon class="icon-m item-icon">view_list</mat-icon>
                </div>
                <span class="body-m item-description">Catalogue</span>
            </a>
            <a
                routerLink="/admin/settings"
                [routerLinkActiveOptions]="{ exact: true }"
                *appFeatureToggling="'catalogue'"
                routerLinkActive="navigation-item__container--selected"
                class="navigation-item__container"
            >
                <div class="item-icon-container">
                <mat-icon class="icon-m item-icon">tune</mat-icon>
                </div>
                <span class="body-m item-description">Settings</span>
            </a>
        </nav>

        <div class="navigation-nav">
            <button class="navigation-item__container" (click)="logout()">
                <div class="item-icon-container">
                    <mat-icon class="icon-m item-icon">exit_to_app</mat-icon>
                </div>
                <span class="body-m item-description">Log out</span>
            </button>
        </div>
    </div>
</div>